export enum APP_QUERY_PARAMS_ACTIONS {
  PAYMENT_METHOD_UPDATED = 'payment_method_updated',
}
